import {useCallback, useEffect, useState} from "react";

import {getCases} from "../../../services/case";
import {getOrganizations} from "../../../services/organization";

type UseCaseManagementDataProps = {
  userToken: string;
};

export const useCaseManagementData = ({userToken}: UseCaseManagementDataProps) => {
  const [cases, setCases] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCases = useCallback(async () => {
    setLoading(true);
    try {
      const tempCases = await getCases({token: userToken});
      setCases(tempCases);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [userToken]);

  const fetchCasesSilently = useCallback(async () => {
    try {
      const tempCases = await getCases({token: userToken});
      setCases(tempCases);
    } catch (err) {
      console.log(err);
    }
  }, [userToken]);

  const fetchOrganizations = useCallback(async () => {
    try {
      const tempOrganizations = await getOrganizations({token: userToken});
      setOrganizations(tempOrganizations);
    } catch (err) {
      console.log(err);
    }
  }, [userToken]);

  useEffect(() => {
    if (userToken) {
      fetchCases();
      fetchOrganizations();
    }
  }, [userToken, fetchCases, fetchOrganizations]);

  useEffect(() => {
    if (!userToken) return;
    const interval = setInterval(() => {
      fetchCasesSilently();
    }, 5000);

    return () => clearInterval(interval);
  }, [userToken, fetchCasesSilently]);

  return {
    cases,
    organizations,
    loading,
    refreshCases: fetchCases,
  };
};
